import { request } from "../../utils/request/request";

export const sendFosDataForm = async (sentData) => {

    const response = await request.post('/application/createFos', sentData);

    return response.data;
};
 